export default function isPermitted(permission: number[], userRoleId: number) {
  if (!permission.includes(userRoleId)) {
    return false;
  }
  return true;
}
